import * as React from 'react'
import { ReactElement, useContext } from 'react'
import {
    Button,
    makeStyles,
    MessageBar,
    MessageBarActions,
    shorthands,
    tokens,
    Image,
} from '@fluentui/react-components'
import IdentityContext, {
    AuthenticationPhase,
    AuthenticationPhaseLabelMap,
    Identity,
    IdentityContextProps,
} from '../../context/IdentityContext'
import SelectHost from './SelectHost'
import SelectAccount from './SelectAccount'
import { bundleIcon, DismissCircleFilled, DismissCircleRegular } from '@fluentui/react-icons'
import { useTranslation } from 'react-i18next'

const useStyles = makeStyles({
    container: {
        display: 'grid',
        ...shorthands.padding(tokens.spacingHorizontalM),
        ...shorthands.gap(tokens.spacingHorizontalM),
    },
    logo: {
        maxHeight: '100px',
    },
})

const DismissCircle = bundleIcon(DismissCircleFilled, DismissCircleRegular)

function Content(): ReactElement {
    const { phase } = useContext<IdentityContextProps>(IdentityContext)
    const { t: translate } = useTranslation()

    switch (phase) {
        case AuthenticationPhase.SelectHost:
            return <SelectHost />
        case AuthenticationPhase.SelectAccount:
            return <SelectAccount />
        default:
            return <>{translate(AuthenticationPhaseLabelMap.get(phase))}</>
    }
}

export default function Authentication(): ReactElement {
    const styles = useStyles()
    const { error } = useContext<IdentityContextProps>(IdentityContext)
    return (
        <div className={styles.container}>
            {error && (
                <MessageBar intent={'error'}>
                    {error}
                    <MessageBarActions
                        containerAction={
                            <Button
                                onClick={() => Identity.current?.clearError()}
                                aria-label="dismiss"
                                appearance="transparent"
                                icon={<DismissCircle />}
                            />
                        }
                    />
                </MessageBar>
            )}
            <Image src={'images/hammock.svg'} className={styles.logo} />
            <Content />
        </div>
    )
}
